import { useState, useEffect } from 'react';

const useIsLowerResolution = () => {
    const [isLowerResolution, setIsLowerResolution] = useState(false);
    if (typeof window === 'undefined') {
        return false;
    }
    const toggleMobile = () => {
        if (window.innerWidth < 592) {
            return setIsLowerResolution(true);
        }
        return setIsLowerResolution(false);
    };
    useEffect(() => {
        let timeoutId = 0;
        const resizeListener = () => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => toggleMobile(), 100);
        };
        window.addEventListener('resize', resizeListener);
        toggleMobile();
        return () => window.removeEventListener('resize', resizeListener);
    }, []);
    return isLowerResolution;
};

export { useIsLowerResolution as default };
